import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e5122aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recharge" }
const _hoisted_2 = { class: "recharge_content" }
const _hoisted_3 = {
  class: "recharge_content_radio",
  style: {"margin-bottom":"10px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_radio_money" }, "充值金额：", -1))
const _hoisted_5 = {
  class: "recharge_content_radio",
  style: {"margin-bottom":"40px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_radio_name" }, "其他金额：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_radio_yuan" }, "元", -1))
const _hoisted_8 = { class: "recharge_content_radio" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_radio_pays" }, "支付方式：", -1))
const _hoisted_10 = { class: "radio_button_content" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "content_text" }
const _hoisted_13 = { class: "content_text_name" }
const _hoisted_14 = { class: "content_text_english" }
const _hoisted_15 = { class: "recharge_content_radio" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_radio_sum" }, "账户余额：", -1))
const _hoisted_17 = { class: "content_radio_balance" }
const _hoisted_18 = { style: {"color":"#fa5555","font-size":"16px"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","margin":"4px 0 0 5px"} }, "元", -1))
const _hoisted_20 = {
  key: 0,
  class: "recharge_content_radio margin_t"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_radio_sum" }, "可用优惠：", -1))
const _hoisted_22 = { class: "content_radio_button" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"Tips\" data-v-4e5122aa><div class=\"Tips_title\" data-v-4e5122aa>温馨提示</div><div class=\"Tips_list\" data-v-4e5122aa>1.单笔账户充值金额下限为2000元，上限为100000元；</div><div class=\"Tips_list\" data-v-4e5122aa>2.账户充值仅支持微信、银行账号打款方式充值；</div><div class=\"Tips_list\" data-v-4e5122aa>3.所充值的账户余额仅作为平台购买版本套餐、购买资源包等作用；</div><div class=\"Tips_list\" data-v-4e5122aa>4.退款需扣除微信/支付宝相应手续费；</div><div class=\"Tips_list\" data-v-4e5122aa>5.当资源包到期或不足时，系统默认扣除相应的账户余额。</div></div>", 1)
const _hoisted_25 = { class: "recharge_Alipay" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "recharge_Alipay_text" }
const _hoisted_29 = { class: "recharge_Alipay_detailed" }
const _hoisted_30 = { class: "Alipay_detailed_line" }
const _hoisted_31 = { class: "Alipay_detailed_line" }
const _hoisted_32 = { class: "Alipay_detailed_line" }
const _hoisted_33 = { style: {"font-size":"16px"} }
const _hoisted_34 = { style: {"width":"100%","text-align":"center","margin-top":"50px","padding-bottom":"70px"} }
const _hoisted_35 = { class: "wxpay_modal" }
const _hoisted_36 = { style: {"font-size":"20px","font-weight":"bold","color":"#333333","text-align":"center"} }
const _hoisted_37 = { style: {"width":"227px","margin":"10px auto","text-align":"center"} }
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#666666","font-size":"14px","font-weight":"500","text-align":"center"} }, "请用微信扫码支付", -1))
const _hoisted_40 = { class: "bank_img_wrap" }
const _hoisted_41 = ["src"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"121px","color":"#666666","font-size":"14px","font-weight":"500"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"14px"} }, "公司名称：上海邦纬科技有限公司"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"14px"} }, "开户行及账号：中国银行上海市安亭支行"),
  /*#__PURE__*/_createElementVNode("div", null, "银行账号：446 879 215 385")
], -1))
const _hoisted_43 = { class: "recharge_bottom" }
const _hoisted_44 = { class: "b_pay" }
const _hoisted_45 = { class: "b_pay_box" }
const _hoisted_46 = { class: "b_pay_num" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "账户余额", -1))
const _hoisted_48 = { class: "b_pay_box" }
const _hoisted_49 = { class: "b_pay_num" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "充值金额", -1))
const _hoisted_51 = { class: "b_pay_box" }
const _hoisted_52 = { class: "b_pay_num" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "减免优惠", -1))
const _hoisted_54 = { class: "b_pay" }
const _hoisted_55 = { class: "b_pay_box" }
const _hoisted_56 = { class: "b_pay_num" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "充值金额", -1))

import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';
import { Bankpay, WeChatpay, sucMsg, failMsg, bankch } from '@/assets';
import { numberToCurrency } from '@/utils/format/number';
import { computed, reactive, createVNode, ref, defineAsyncComponent } from 'vue';
import type { MoneyOption, PayTypeOption } from './types';
import { Radio, InputNumber, Modal, Spin, message } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import http from '@/api/account';
import { useRouter } from 'vue-router';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { useHomeStore } from '@/pinia/home';
import type { ICoupon } from './types';

// `qrcode` will be a ref of data URL
import { useDebounce } from '@/hooks/useDebounce';
import { getToken } from '@/plugins/cookie';


const __default__ = {
  name: 'accountRecharge',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const homeStore = useHomeStore();

const isNewVersion = computed(() => homeStore.isNewVersion);
const Coupon = defineAsyncComponent(() => import('./cardBag/Coupon.vue'));
const aRadioGroup = Radio.Group;
const aRadioButton = Radio.Button;
const aInputNumber = InputNumber;
const aModal = Modal;
const aSpin = Spin;
const router = useRouter();
const moneyList: MoneyOption[] = [
  {
    name: '2,000元',
    value: 2000,
  },
  {
    name: '5,000元',
    value: 5000,
  },
  {
    name: '10,000元',
    value: 10000,
  },
  {
    name: '20,000元',
    value: 20000,
  },
  {
    name: '50,000元',
    value: 50000,
  },
  // {
  //   name: '10,000元',
  //   value: 10000,
  // },
];
const payTypeList: PayTypeOption[] = [
  // {
  //   payId: 2,
  //   cname: '支付宝',
  //   name: 'ALIPAY',
  //   img: Alipay
  // },
  {
    payId: 1,
    cname: '微信支付',
    name: 'WECHAT PAY',
    img: WeChatpay,
  },
  // {
  //   payId: 4,
  //   cname: '线下支付',
  //   name: 'BALANCE PAY',
  //   img: Bankpay,
  // },
];
const rechargeConfig = reactive({
  bank: false,
  content: true, // 充值界面显示
  success: false, // 充值结果状态

  formPrice: 2000,
  payType: 1, // 支付类型
  balance: '', // 余额
  rechargeStatus: false, // 是否阅读规则
  visableRules: false, // 充值规则显示
  errMsg: '很抱歉，支付失败！',

  weChatModal: false, // 二维码生成弹框
});

const price = computed(() => rechargeConfig.formPrice - favourable.value);
const formatBalance = computed(() => numberToCurrency(rechargeConfig.balance));
const formatFormPrice = computed(() => numberToCurrency(price.value));
const formatPrice = computed(() =>
  rechargeForm.selectPrice ? rechargeForm.selectPrice - favourable.value : rechargeForm.inputPrice - favourable.value
);

// form 选项金额 输入金额
const rechargeForm = reactive({
  selectPrice: 2000,
  inputPrice: 2000,
});

const clearSelectOption = () => {
  rechargeForm.selectPrice = 0;
};
const clearInputOption = () => {
  rechargeForm.inputPrice = 2000;
};
const payTypeChange = () => {
  if (rechargeConfig.payType === 4) {
    rechargeConfig.bank = true;
  }
};

// 返回
const payBack = () => {
  if (rechargeConfig.success) {
    router.replace({ name: 'Home' });
  } else {
    rechargeConfig.content = true;
  }
};

//
const callBackData = reactive<{
  wxCode: string;
  order: string;
  orderTimer: any;
}>({
  wxCode: '',
  order: '',
  orderTimer: '',
});
const clearWXcode = () => {
  clearInterval(callBackData.orderTimer);
  callBackData.wxCode = '';
  rechargeConfig.weChatModal = false;
};

const indicator = createVNode(LoadingOutlined, {
  style: {
    fontSize: '24px',
  },
  spin: true,
});

const rechargeBtn = ref(true);
const getBalance = () => {
  http
    .getTheRemainingBalance()
    .then((res) => {
      rechargeConfig.balance = parseFloat(res.data.data.balance).toFixed(2);
      rechargeBtn.value = false;
    })
    .catch((err) => {
      console.error(err);
    });
};

const weChatPay = () => {
  const data = {
    amount: 0,
    pay_type: 1,
    token: getToken(),
    coupon_id: lessCouponKey.value,
  };
  rechargeConfig.formPrice = rechargeForm.selectPrice ? rechargeForm.selectPrice : rechargeForm.inputPrice;

  data.amount = rechargeConfig.formPrice;
  data.pay_type = rechargeConfig.payType;
  // rechargeConfig.weChatModal = true;
  http
    .generateAccountRechargeOrder(data)
    // 生成订单号
    .then((res) => {
      rechargeConfig.weChatModal = true;
      callBackData.order = res.data.data.order_no;
      clearInterval(callBackData.orderTimer);
      return http.weChatScanPay({
        params: {
          order_no: res.data.data.order_no,
          pay_type: 4, // 接口特定参数，表充值
        },
      });
    })
    // 生成支付二维码
    .then((resRQcode: any) => {
      callBackData.wxCode = resRQcode.data.data; //获取二维码
      callBackData.orderTimer = setInterval(() => {
        // 轮询订单状态
        http
          .balanceRechargeCallback({
            params: {
              token: getToken(),
              order_no: callBackData.order,
              pay_type: rechargeConfig.payType,
            },
          })
          .then((res) => {
            if (res.data.data.code != 40003) {
              // 查询余额
              getBalance();
              clearWXcode();
              rechargeConfig.success = true;
              rechargeConfig.content = false;
              setTimeout(() => {
                payBack();
              }, 3000);
            }
          })
          .catch((res) => {
            rechargeConfig.success = false;
            rechargeConfig.content = false;
            rechargeConfig.errMsg = res.data.error && res.data.error;
          });
      }, 1000);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 支付提示
const cofrimModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const openCofrimModal = () => {
  const reqStr = /^[0-9]*[1-9][0-9]*$/.test(rechargeForm.inputPrice.toString());
  if (rechargeForm.selectPrice >= 2000 || (reqStr && rechargeForm.inputPrice >= 2000 && rechargeForm.selectPrice === 0)) {
    cofrimModal.visible = true;
  } else {
    message.destroy();
    message.warning('请输入整数金额，充值金额最少为2000元！');
  }
};
const onCancelModal = () => {
  cofrimModal.loading = false;
  cofrimModal.visible = false;
};

const subPay = useDebounce(() => {
  // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);

  switch (rechargeConfig.payType) {
    case 1:
      weChatPay();
      onCancelModal();
      break;
    case 2:
      // 支付宝
      break;
    case 4:
      // 银行
      onCancelModal();
      rechargeConfig.bank = true;
      break;
  }
  // Modal.confirm({
  //   centered: true,
  //   content: () => '是否确定支付?',
  //   icon: () => createVNode(ExclamationCircleOutlined),
  //   onOk() {
  //     return new Promise((resolve, reject) => {
  //       // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
  //       const reqStr = /^[0-9]*[1-9][0-9]*$/.test(
  //         rechargeForm.inputPrice.toString()
  //       );
  //       if (
  //         !reqStr &&
  //         rechargeForm.inputPrice >= 0 &&
  //         rechargeForm.selectPrice === 0
  //       ) {
  //         message.warning('请输入整数金额，充值金额最少为1元！');
  //         return resolve({});
  //       }
  //       switch (rechargeConfig.payType) {
  //         case 1:
  //           weChatPay();
  //           return resolve({});
  //         case 2:
  //           // 支付宝
  //           break;
  //         case 4:
  //           // 银行
  //           rechargeConfig.bank = true;
  //       }
  //     }).catch(() => console.log('Oops errors!'));
  //   },
  //   // eslint-disable-next-line @typescript-eslint/no-empty-function
  //   onCancel() {},
  // });
});
const init = () => {
  getBalance();
};
init();

const url = computed(() => callBackData.wxCode);
const qrcode = useQRCode(url, { margin: 0 });

const cardCouponList = ref<ICoupon[]>([]);
const getCardCouponList = () => {
  const data = { type: [1, 2, 3, 4], hidden_expire: 1 };
  http
    .getCardCouponList({ params: data })
    .then((res) => {
      const resData = res.data.data.data;
      resData.forEach((e: any) => {
        if (e.card_type === 1) {
          e.background = lessCoupon[e.card_name].background;
          e.color = lessCoupon[e.card_name].color;
        }
        if (e.card_type === 4) {
          e.background = lessCoupon[e.card_name].background;
          e.color = lessCoupon[e.card_name].color;
        }
      });
      cardCouponList.value = resData;
    })
    .catch(() => {
      //
    });
};
getCardCouponList();
const lessCoupon = {
  代金券: {
    background: require('@/assets/resource/coupon_era.png'),
    color: ['#6A1A11', '#6A1A11'],
    type: '代金券',
  },
  增值券: {
    background: require('@/assets/resource/coupon_add.png'),
    color: ['#F9E5B6', '#B6453A'],
    type: '增值券',
  },
};
//   {
//     background: require('@/assets/resource/coupon_sense.png'),
//     color: ['#FFFFFF', '#E29C47'],
//     type: '体验券',
//   },
// ];
const lessCouponKey = ref();
const favourable = ref(0); // 优惠金额
const lessCouponItem = ref<ICoupon>();
const clickUseCoupon = (item: ICoupon) => {
  lessCouponKey.value = item.id;
  lessCouponItem.value = item;
  item.card_type === 1 ? (favourable.value = item.quota) : (favourable.value = 0);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(aRadioGroup), {
              value: rechargeForm.selectPrice,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rechargeForm.selectPrice) = $event)),
              class: "content_radio_button",
              onChange: clearInputOption
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(moneyList, (item) => {
                  return _createVNode(_unref(aRadioButton), {
                    class: "radio_button",
                    style: {"width":"150px","height":"45px"},
                    key: item.value,
                    value: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(aInputNumber), {
              value: rechargeForm.inputPrice,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((rechargeForm.inputPrice) = $event)),
              valueModifiers: { number: true },
              style: {"width":"150px"},
              size: "large",
              min: 2000,
              max: 100000,
              step: 1000,
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (clearSelectOption()))
            }, null, 8, ["value"]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_unref(aRadioGroup), {
              value: rechargeConfig.payType,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((rechargeConfig.payType) = $event)),
              class: "content_radio_button",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (payTypeChange())),
              size: "large"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(payTypeList, (item) => {
                  return _createVNode(_unref(aRadioButton), {
                    key: item.img,
                    value: item.payId,
                    class: "radio_button",
                    size: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          class: "content_img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_11),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.cname), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, "￥" + _toDisplayString(_unref(formatBalance)), 1),
              _hoisted_19
            ])
          ]),
          (_unref(isNewVersion) && cardCouponList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardCouponList.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      onClick: ($event: any) => (clickUseCoupon(item))
                    }, [
                      _createVNode(_unref(Coupon), {
                        "data-source": item,
                        choice: lessCouponKey.value
                      }, null, 8, ["data-source", "choice"])
                    ], 8, _hoisted_23))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_24
      ], 512), [
        [_vShow, rechargeConfig.content]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_25, [
        (rechargeConfig.success)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "recharge_Alipay_img",
              src: _unref(sucMsg),
              alt: ""
            }, null, 8, _hoisted_26))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "recharge_Alipay_img",
              src: _unref(failMsg),
              alt: ""
            }, null, 8, _hoisted_27)),
        _createElementVNode("div", _hoisted_28, _toDisplayString(rechargeConfig.success ? '购买成功' : rechargeConfig.errMsg), 1),
        _withDirectives(_createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, "账户余额：￥" + _toDisplayString(_unref(formatBalance)), 1),
          _createElementVNode("div", _hoisted_31, "可用余额：￥" + _toDisplayString(_unref(formatBalance)), 1),
          _createElementVNode("div", _hoisted_32, [
            _createTextVNode(" 购买金额： "),
            _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(formatFormPrice)) + " 元", 1)
          ])
        ], 512), [
          [_vShow, rechargeConfig.success]
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (payBack()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(rechargeConfig.success ? '确定' : '返回充值页面'), 1)
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, !rechargeConfig.content]
      ]),
      _createVNode(_unref(aModal), {
        visible: rechargeConfig.weChatModal,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((rechargeConfig.weChatModal) = $event)),
        title: "收银台",
        centered: "",
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (clearWXcode())),
        footer: null
      }, {
        footer: _withCtx(() => [
          _withDirectives(_createVNode(_component_a_button, { key: "back" }, null, 512), [
            [_vShow, !rechargeConfig.weChatModal]
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(formatFormPrice)) + "元", 1),
            _createElementVNode("div", _hoisted_37, [
              (!callBackData.wxCode)
                ? (_openBlock(), _createBlock(_unref(aSpin), {
                    key: 0,
                    style: {"width":"50px","margin":"50px auto"},
                    indicator: _unref(indicator)
                  }, null, 8, ["indicator"]))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _unref(qrcode),
                    style: {"width":"150px"},
                    alt: "QR Code"
                  }, null, 8, _hoisted_38))
            ]),
            _hoisted_39
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        class: "bank_wrap",
        visible: rechargeConfig.bank,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((rechargeConfig.bank) = $event)),
        title: "线下支付",
        centered: "",
        footer: null
      }, {
        footer: _withCtx(() => [
          _withDirectives(_createVNode(_component_a_button, { key: "back" }, null, 512), [
            [_vShow, !rechargeConfig.bank]
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("img", {
                style: {"width":"260px","height":"75px"},
                src: _unref(bankch),
                alt: ""
              }, null, 8, _hoisted_41)
            ]),
            _hoisted_42
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(CDelModal, {
        visible: cofrimModal.visible,
        centered: "",
        close: onCancelModal,
        ok: _unref(subPay)
      }, {
        title: _withCtx(() => [
          _createTextVNode("是否确定支付？")
        ]),
        _: 1
      }, 8, ["visible", "ok"])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("p", _hoisted_46, _toDisplayString(_unref(formatBalance)), 1),
          _hoisted_47
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(formatPrice)), 1),
          _hoisted_50
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("p", _hoisted_52, _toDisplayString(lessCouponItem.value?.card_type === 1 ? lessCouponItem.value.quota : 0), 1),
          _hoisted_53
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("p", _hoisted_56, _toDisplayString(_unref(formatPrice)), 1),
          _hoisted_57
        ]),
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: rechargeBtn.value,
          onClick: _cache[9] || (_cache[9] = ($event: any) => (openCofrimModal()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("立即充值")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ], 64))
}
}

})